import path from 'path';

/****************************************************
 *
 *                    CUSTOM STORAGE
 *
 ***************************************************/
const storage_prefix =
  process.env.NODE_ENV === 'development' ? 'its_dev_' : 'its_prod_';

const getKeyName = (key: any) => `${storage_prefix}${key}`;
const checkStoreKey = (key: any) => localStorage.key(key);
const checkSessionKey = (key: any) => sessionStorage.key(key);

const encryptStoreData = (data: any) => window.btoa(data);
const decryptStoreData = (data: any) => window.atob(data);

export const storageSet = (key: any, data: any) => {
  let storeData = JSON.stringify(data);
  storeData = encryptStoreData(storeData);
  localStorage.setItem(getKeyName(key), storeData);
};

export const storageRemove = (key: any) => {
  const storeKey = getKeyName(key);
  if (checkStoreKey(storeKey)) {
    return localStorage.removeItem(storeKey);
  }
};

export const storageGet = (key: any) => {
  const storeKey = getKeyName(key);
  const check = checkStoreKey(storeKey);
  if (!check) return null;

  let data = localStorage.getItem(storeKey);
  if ((check || !check) && (!data || data === 'undefined' || data === null)) {
    storageRemove(storeKey);
    return null;
  }
  data = decryptStoreData(data);
  data = JSON.parse(data);
  return data as any;
};

export const sessionSet = (key: string, data: any) => {
  let storeData = JSON.stringify(data);
  storeData = encryptStoreData(storeData);
  sessionStorage.setItem(getKeyName(key), storeData);
};

export const sessionRemove = (key: string) => {
  const storeKey = getKeyName(key);
  if (checkSessionKey(storeKey)) {
    return sessionStorage.removeItem(storeKey);
  }
};

export const sessionGet = (key: string) => {
  const storeKey = getKeyName(key);
  const check = checkSessionKey(storeKey);
  if (!check) return null;

  let data = sessionStorage.getItem(storeKey);
  if ((check || !check) && (!data || data === 'undefined' || data === null)) {
    sessionRemove(storeKey);
    return null;
  }
  data = decryptStoreData(data);
  data = JSON.parse(data);
  return data;
};

//  ** logged in user
export const isUserLoggedIn = () => storageGet('token');

// ** phonne regex
export const phoneRegExp =
  /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;

// ** date formats
export const formatLocaleDate = (date: Date, separator: string) => {
  let str = date.toLocaleDateString('en-GB');
  str = str.replace(/\//g, separator);
  return str;
};

export const fDate = (date: Date) => {
  const options: IDateOptions = {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  };

  const d = new Date(date).getDate();
  const m = new Intl.DateTimeFormat('en-GB', { month: options.month }).format(
    date
  );
  const y = new Date(date).getFullYear();

  if (d > 3 && d < 21) return `${d}th ${m}, ${y}`;
  switch (d % 10) {
    case 1:
      return `${d}st ${m}, ${y}`;
    case 2:
      return `${d}nd ${m}, ${y}`;
    case 3:
      return `${d}rd ${m}, ${y}`;
    default:
      return `${d}th ${m}, ${y}`;
  }
  // return d;
};

// ** format pathname
export const formatPathname = (pathname: string) => {
  return (
    pathname.split('/')[2].replace(/\-/g, ' ').charAt(0).toUpperCase() +
    pathname.split('/')[2].replace(/\-/g, ' ').slice(1).toLowerCase()
  );
};

// ** table sort and search
export const descendingComparator = (a: any, b: any, orderBy: string) => {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
};

export const getComparator = (
  order: 'ascending' | 'descending',
  orderBy: string
) => {
  return order === 'descending'
    ? (a: any, b: any) => descendingComparator(a, b, orderBy)
    : (a: any, b: any) => -descendingComparator(a, b, orderBy);
};

export const applySortFilter = (
  array: any[],
  comparator: (arg0: any, arg1: any) => any,
  query: string
) => {
  if (array?.length > 0) {
    const stabilizedThis = array.map((el: any, index: any) => [el, index]);
    stabilizedThis.sort((a: number[], b: number[]) => {
      const order = comparator(a[0], b[0]);
      if (order !== 0) return order;
      return a[1] - b[1];
    });

    if (query) {
      return array.filter((data) => {
        return Object.values(data)?.filter((value) =>
          String(value).toLowerCase().includes(query.toLowerCase())
        )[0];
      });
    }
    return stabilizedThis.map((el: any[]) => el[0]);
  }
};

//  ** format underscore keys
export const formatUnderscoreKeys = (string: string) => {
  return string.replace(/\_/g, ' ');
};
